export default __webpack_public_path__ + "static/media/last-gift-bg.38c46ca1.png";